<!-- src/components/ezer/EzerFeedback.vue -->
<template>
  <div class="ezer-feedback">
    <!-- Satisfied confirmation -->
    <div v-if="feedbackState === 'satisfied'" class="ezer-feedback__confirmed">
      <svg viewBox="0 0 20 20" width="14" height="14" fill="var(--ezer-primary)">
        <path d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm3.5-9.5l-4 4a.7.7 0 0 1-1 0l-2-2a.7.7 0 1 1 1-1L9 11l3.5-3.5a.7.7 0 1 1 1 1z"/>
      </svg>
      Thanks for your feedback!
    </div>

    <!-- Admin requested confirmation -->
    <div v-else-if="feedbackState === 'admin_requested'" class="ezer-feedback__confirmed ezer-feedback__confirmed--admin">
      <svg viewBox="0 0 20 20" width="14" height="14" fill="currentColor">
        <path d="M2.94 3.34a.5.5 0 0 1 .65-.24l14 6.5a.5.5 0 0 1 0 .9l-14 6.5a.5.5 0 0 1-.7-.58L4.56 11H10a.5.5 0 0 0 0-1H4.56L2.89 3.92a.5.5 0 0 1 .05-.58z"/>
      </svg>
      An administrator has been notified and will get back to you shortly via email.
    </div>

    <!-- Ask if user wants admin help (shown after "No") -->
    <div v-else-if="feedbackState === 'unsatisfied'" class="ezer-feedback__escalate">
      <p class="ezer-feedback__question">Would you like to request assistance from an Administrator?</p>
      <div class="ezer-feedback__actions">
        <button class="ezer-feedback__btn ezer-feedback__btn--primary" @click="$emit('request-admin')">
          Yes, request help
        </button>
        <button class="ezer-feedback__btn ezer-feedback__btn--muted" @click="$emit('dismiss-feedback')">
          No thanks
        </button>
      </div>
    </div>

    <!-- Initial feedback prompt -->
    <div v-else-if="feedbackState === 'pending'" class="ezer-feedback__prompt">
      <p class="ezer-feedback__question">Did this answer your question?</p>
      <div class="ezer-feedback__actions">
        <button class="ezer-feedback__btn ezer-feedback__btn--yes" @click="$emit('feedback', true)" aria-label="Yes">
          <svg viewBox="0 0 20 20" width="14" height="14" fill="currentColor"><path d="M2 10.5a1.5 1.5 0 0 1 3 0v6a1.5 1.5 0 0 1-3 0v-6zm4.5-1.75a.75.75 0 0 1 .75-.75h5a3 3 0 0 0 2.9-2.24l.53-2.13A1.5 1.5 0 0 0 14.22 2H12.5a.75.75 0 0 1-.75-.75A1.25 1.25 0 0 0 10.5 0h-1A3.5 3.5 0 0 0 6 3.5v5.25z"/></svg>
          Yes
        </button>
        <button class="ezer-feedback__btn ezer-feedback__btn--no" @click="$emit('feedback', false)" aria-label="No">
          <svg viewBox="0 0 20 20" width="14" height="14" fill="currentColor" style="transform:rotate(180deg)"><path d="M2 10.5a1.5 1.5 0 0 1 3 0v6a1.5 1.5 0 0 1-3 0v-6zm4.5-1.75a.75.75 0 0 1 .75-.75h5a3 3 0 0 0 2.9-2.24l.53-2.13A1.5 1.5 0 0 0 14.22 2H12.5a.75.75 0 0 1-.75-.75A1.25 1.25 0 0 0 10.5 0h-1A3.5 3.5 0 0 0 6 3.5v5.25z"/></svg>
          No
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EzerFeedback',
  props: {
    feedbackState: { type: String, default: null },
  },
  emits: ['feedback', 'request-admin', 'dismiss-feedback'],
}
</script>
